import { render } from "./LinedTextareaExternal.vue?vue&type=template&id=50a51644&scoped=true"
import script from "./LinedTextareaExternal.vue?vue&type=script&lang=js"
export * from "./LinedTextareaExternal.vue?vue&type=script&lang=js"

import "./LinedTextareaExternal.vue?vue&type=style&index=0&id=50a51644&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50a51644"

export default script